import React, { useState } from "react";
import CommonTable from "../../../global/table";
import CommonCardView from "../../../global/cardView";
import NoRecordFound from "../../../global/noRecordFound";
import { formatDateTime, formatDateTimeFromNow } from "../../../../utils/functions";
import EnhancePaymentHistoryCardView from "./enhance-payment-history-card-view";
import CommonDrawer from "../../../global/drawer";
import EnhancedPaymentHistoryDetails from "./enhanced-payment-history-details";

const EnhancedPaymentHistoryList = ({
    isLoading,
    history,
    paymentHistoryViewType,
    sortBy,
    sortOrder,
    onSort,
}) => {
    const [paymentDetails, setPaymentDetails] = useState({
        show: false,
        data: null
    });

    const columns = [
        {
            title: "Payment At",
            dataIndex: "paymentAt",
            key: "paymentAt",
            sortType: "Payment At",
            render: (text, record) => (
                <div className="flex flex-col">
                    <span className="font-semibold text-gray-800">{record.paymentAt}</span>
                    <span className="text-[11px] text-gray-400 font-medium">{record.paymentAtFromNow}</span>
                </div>
            ),
        },
        {
            title: "Payment Gateway",
            dataIndex: "paymentGateway",
            key: "paymentGateway",
            sortType: "Payment Gateway",
            render: (text) => (
                <span className="px-3 py-1 bg-gray-50 text-gray-600 rounded-full text-xs font-bold border border-gray-100 uppercase tracking-wider">
                    {text}
                </span>
            )
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            sortType: "Amount",
            render: (text) => (
                <span className="font-bold text-success text-sm">
                    {text}
                </span>
            )
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (text) => (
                <span className="text-gray-500 font-medium text-sm italic">
                    {text}
                </span>
            )
        },
    ];

    const data = Array.isArray(history) && history.length > 0
        ? history.map((item, index) => ({
            ...item,
            key: item._id || index,
            id: item._id,
            paymentAt: formatDateTime(item.createdAt),
            paymentAtFromNow: formatDateTimeFromNow(item.createdAt),
            amount: `${item.amount} $`,
            originalData: item
        }))
        : [];

    return (
        <>
            {data.length > 0 ? (
                <>
                    {paymentHistoryViewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={{ sortType: sortBy === "createdAt" ? "Payment At" : sortBy, sortOrder }}
                            setSort={(sortObj) => {
                                const fieldMap = {
                                    "Payment At": "createdAt",
                                    "Payment Gateway": "paymentGateway",
                                    "Amount": "amount"
                                };
                                onSort(fieldMap[sortObj.sortType] || sortObj.sortType);
                            }}
                            onRowClick={(record) => setPaymentDetails({ show: true, data: record.originalData })}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancePaymentHistoryCardView
                                    key={record.key}
                                    record={record}
                                    onCardClick={(record) => setPaymentDetails({ show: true, data: record.originalData })}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                !isLoading && <NoRecordFound message="No payment history records found." />
            )}

            {paymentDetails.show && (
                <CommonDrawer
                    open={paymentDetails.show}
                    setOpen={() => setPaymentDetails({ show: false, data: null })}
                    title="Payment Details"
                    width={"1000px"}
                    children={
                        <EnhancedPaymentHistoryDetails
                            paymentDetail={paymentDetails.data}
                        />
                    }
                />
            )}
        </>
    );
};

export default EnhancedPaymentHistoryList;
